import { supabase } from '../supabase.js'

export function extractEndpoint() {
  const fromEnv = String((typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_EXTRACT_URL) || '').replace(/\/$/, '')
  if (fromEnv) return fromEnv
  // ローカル（Vite）は `api/extract` の Workers が同梱されていないことがあるため、
  // その場合でも Production の抽出APIへフォールバックする。
  if (typeof location !== 'undefined' && location.origin) {
    if (/veil-neb\.pages\.dev$/i.test(location.hostname)) return `${location.origin}/api/extract`
  }
  return 'https://veil-neb.pages.dev/api/extract'
}

export async function extractDraftFromPath(path, filename) {
  const url = extractEndpoint()
  if (!url) throw new Error('抽出の接続先が未設定です（VITE_EXTRACT_URL）')
  if (!supabase) throw new Error('接続できません')
  const { data } = await supabase.auth.getSession()
  const token = data && data.session && data.session.access_token
  if (!token) throw new Error('サインインしてください')
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Veil-Token': token },
    body: JSON.stringify({ path, filename: filename || '', accessToken: token }),
  })
  let body = {}
  try { body = await res.json() } catch { body = {} }
  if (!res.ok) throw new Error(body.error || '抽出に失敗しました')
  return { draft: body.draft || {}, preview: body.preview || '' }
}
